import mapsModule from "@/store/modules/maps.module";
import CustomControl from "./custom-control";
import globalModule from "@/store/modules/global.module";

export default class ChangeMapControl extends CustomControl {
    constructor() {
        super(ChangeMapControl.buildHtml());
    }

    addEvents(element: HTMLElement) {
        element.querySelector('button')!.querySelector('.osm')!.addEventListener('click', () => globalModule.setMapLayer('ostm'), false)
        element.querySelector('button')!.querySelector('.bing')!.addEventListener('click', () => globalModule.setMapLayer('bingmaps'), false)
    }

    static buildHtml() {
        const element = document.createElement('div')
        element.className = 'capas-container ol-control'
        const button = document.createElement('button')
        button.className = 'capas'
        button.innerHTML = `
            <input type="radio" name="capa" style="display: none;" id="osm" checked value="ostm">
            <label for="osm" class="osm label-capas">
            <img src="${require('@/assets/img/bing2.png')}">
            </label>
            <input type="radio" name="capa" style="display: none;" id="bing" value="bingmaps">
            <label for="bing" class="bing label-capas">
            <img src="${require('@/assets/img/ostm2.png')}">
            </label>
        `
        element.appendChild(button)
        return element
    }


}